import { Text } from "@overmap-ai/blocks"
import { type ProcedureInitiative, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { ProcedureTypeIcon } from "../Icons/ProcedureTypeIcon"
import { ProcedureInitiativeIndexLabel } from "../IndexLabels/ProcedureInitiativeIndexLabel"
import { ProjectTimelineCard } from "./ProjectTimelineCard"
import { getTimelineDate } from "./utils"

interface ProjectTimelineProcedureInitiativeItemProps {
	procedureInitiative: Stored<ProcedureInitiative>
}

export const ProjectTimelineProcedureInitiativeItem = memo<ProjectTimelineProcedureInitiativeItemProps>((props) => {
	const { procedureInitiative } = props

	const user = useAppSelector(selectUserById(procedureInitiative.created_by ?? -1))

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.PROCEDURE_INITIATIVE}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;created procedure initiative&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/initiatives/$procedureInitiativeId"
					params={{ procedureInitiativeId: procedureInitiative.uuid }}
				>
					<Text highContrast className={interactiveTextCva()}>
						<ProcedureTypeIcon className="align-sub" procedureTypeId={procedureInitiative.procedure_type} />
						&nbsp;
						<ProcedureInitiativeIndexLabel procedureInitiativeId={procedureInitiative.uuid} highContrast />
					</Text>
				</Link>
				<Text accentColor="base">
					&nbsp;&#8226;&nbsp;{formatCompactDate(getTimelineDate(procedureInitiative))}
				</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineProcedureInitiativeItem.displayName = "ProjectTimelineProcedureInitiativeItem"
